// Mailcoach subscription list URL mappings
export const MAILCOACH_LISTS = {
  'product-updates': 'https://dash.geocod.io/mailcoach/subscribe/bb8d69f1-cc53-4f56-850c-e55b1b11f782',
  'code-and-coordinates': 'https://dash.geocod.io/mailcoach/subscribe/7c7994d0-937a-4c56-83f9-3f827caabeb2'
}

// Default list if none specified
export const DEFAULT_LIST = 'product-updates'

// Get URL for a list ID, falling back to default if not found
export const getMailcoachUrl = (listId) => {
  return MAILCOACH_LISTS[listId] || MAILCOACH_LISTS[DEFAULT_LIST]
}
